(function () {
  'use strict';

  const ZOOM_HANDLER_KEY = '_variantZoomClickHandler';

  customElements.get('zoom-images') ||
    customElements.define(
      'zoom-images',
      class extends HTMLElement {
        constructor() {
          super();
          this.mediaContainer = this.closest('[data-product-single-media-group]');
          this.slider = this.mediaContainer?.querySelector('[data-product-single-media-slider]');
          this.a11y = window.theme.a11y;
        }

        connectedCallback() {
          this.bindZoomHandlers();
        }

        getVisibleZoomWrappers() {
          if (!this.mediaContainer) return [];

          const slider = this.slider || this.mediaContainer.querySelector('[data-product-single-media-slider]');
          const stash = this.mediaContainer.querySelector('[data-variant-media-stash]');

          if (!slider) {
            return [...this.mediaContainer.querySelectorAll('[data-zoom-wrapper]')];
          }

          const wrappers = [...slider.querySelectorAll('[data-zoom-wrapper]')];

          return wrappers
            .filter((wrapper) => {
              const slide = wrapper.closest('[data-product-single-media-wrapper]');
              if (!slide) return true;
              if (stash?.contains(slide)) return false;
              if (slide.classList.contains('variant-media-group--hidden')) return false;
              return true;
            })
            .sort((left, right) => {
              const leftSlide = left.closest('[data-product-single-media-wrapper]');
              const rightSlide = right.closest('[data-product-single-media-wrapper]');
              const leftIndex = parseInt(leftSlide?.dataset?.mediaSortIndex || '0', 10);
              const rightIndex = parseInt(rightSlide?.dataset?.mediaSortIndex || '0', 10);
              return leftIndex - rightIndex;
            });
        }

        bindZoomHandlers() {
          if (!this.mediaContainer || this.mediaContainer[ZOOM_HANDLER_KEY]) return;

          this.mediaContainer[ZOOM_HANDLER_KEY] = (event) => {
            const wrapper = event.target.closest('[data-zoom-wrapper]');
            if (!wrapper || !this.mediaContainer.contains(wrapper)) return;
            if (this.slider?.classList.contains('is-moving')) return;

            const visibleWrappers = this.getVisibleZoomWrappers();
            const index = visibleWrappers.indexOf(wrapper);
            if (index < 0) return;

            event.preventDefault();
            this.a11y.state.trigger = wrapper;
            this.createZoom(index, visibleWrappers);
          };

          this.mediaContainer.addEventListener('click', this.mediaContainer[ZOOM_HANDLER_KEY]);
        }

        createZoom(index, zoomWrappers) {
          const items = zoomWrappers.map((wrapper) => {
            const src = wrapper.getAttribute('href');
            const width = parseInt(wrapper.getAttribute('data-image-width'), 10);
            const height = parseInt(wrapper.getAttribute('data-image-height'), 10);

            return {
              src,
              w: width,
              h: height,
              msrc: src,
            };
          });

          let mainClass = 'pswp-zoom-gallery';
          if (items.length === 1) {
            mainClass = 'pswp-zoom-gallery pswp-zoom-gallery--single';
          }

          const options = {
            barsSize: { top: 60, bottom: 60 },
            history: false,
            focus: false,
            index,
            mainClass,
            showHideOpacity: true,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: false,
            closeEl: true,
            closeElClasses: ['caption-close'],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 2,
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false,
          };

          new window.theme.LoadPhotoswipe(items, options);
        }
      }
    );
})();
